import type { IPBTCase, IUpdatePbtCaseRequest } from '../../../Interfaces/IPBTCase';

// PBT Cases Action types
export const PBTCasesActionType = {
    REQUEST_CASES: 'PBT/REQUEST_CASES',
    RECEIVE_CASES: 'PBT/RECEIVE_CASES',
    ERROR_CASES: 'PBT/ERROR_CASES',
    RESET_CASES: 'PBT/RESET_CASES',
    UPDATE_CASE_REQUEST: 'PBT/UPDATE_CASE_REQUEST',
    UPDATE_CASE_SUCCESS: 'PBT/UPDATE_CASE_SUCCESS',
    UPDATE_CASE_ERROR: 'PBT/UPDATE_CASE_ERROR',
} as const;

export type PBTCasesAction = IRequestCasesAction | IReceiveCasesAction | IErrorCasesAction | IResetCasesAction | IUpdateCaseRequestAction | IUpdateCaseSuccessAction | IUpdateCaseErrorAction;

// request cases
export interface IRequestCasesAction {
    type: typeof PBTCasesActionType.REQUEST_CASES;
}

export interface IReceiveCasesAction {
    type: typeof PBTCasesActionType.RECEIVE_CASES;
    data: IPBTCase[];
}

export interface IErrorCasesAction {
    type: typeof PBTCasesActionType.ERROR_CASES;
    errorMessage?: string;
}

export interface IResetCasesAction {
    type: typeof PBTCasesActionType.RESET_CASES;
}

export interface IUpdateCaseRequestAction {
    type: typeof PBTCasesActionType.UPDATE_CASE_REQUEST;
    caseId: number;
    request: IUpdatePbtCaseRequest;
}

export interface IUpdateCaseSuccessAction {
    type: typeof PBTCasesActionType.UPDATE_CASE_SUCCESS;
    updatedCase: IPBTCase;
}

export interface IUpdateCaseErrorAction {
    type: typeof PBTCasesActionType.UPDATE_CASE_ERROR;
    errorMessage: string;
}
